<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<h2 class="fm-title">ABBREVIATIONS</h2>
<p class="tababb"><span class="tababb01">ASEA</span> Allmanna Svenska Elektriska Aktiebolaget</p>
<p class="tababb"><span class="tababb01">ASLEF</span> Association of Locomotive Engineers and Firemen</p>
<p class="tababb"><span class="tababb01">BBC</span> British Broadcasting Corporation</p>
<p class="tababb"><span class="tababb01">BEF</span> British Expeditionary Force</p>
<p class="tababb"><span class="tababb01">BFB</span> Bulleid-Firth-Brown</p>
<p class="tababb"><span class="tababb01">BRB</span> British Railways Board</p>
<p class="tababb"><span class="tababb01">BTC</span> British Transport Commission</p>
<p class="tababb"><span class="tababb01">BTH</span> British Thomson-Houston Company</p>
<p class="tababb"><span class="tababb01">CEB</span> Central Electricity Board</p>
<p class="tababb"><span class="tababb01">CLESC</span> County of London Electricity Supply Company</p>
<p class="tababb"><span class="tababb01">CLR</span> Central London Railway</p>
<p class="tababb"><span class="tababb01">DAB</span> delayed action bomb</p>
<p class="tababb"><span class="tababb01">EMU</span> Electric Multiple Unit</p>
<p class="tababb"><span class="tababb01">GER</span> Great Eastern Railway</p>
<p class="tababb"><span class="tababb01">GNR</span> Great Northern Railway</p>
<p class="tababb"><span class="tababb01">GPO</span> General Post Office</p>
<p class="tababb"><span class="tababb01">GWR</span> Great Western Railway</p>
<p class="tababb"><span class="tababb01">HV</span> high voltage</p>
<p class="tababb"><span class="tababb01">Hz</span> hertz</p>
<p class="tababb"><span class="tababb01">kW</span> kilowatt</p>
<p class="tababb"><span class="tababb01">LBSCR</span> London, Brighton and South Coast Railway</p>
<p class="tababb"><span class="tababb01">LCC</span> London County Council</p>
<p class="tababb"><span class="tababb01">LCDR</span> London, Chatham and Dover Railway</p>
<p class="tababb"><span class="tababb01">LESC</span> London Electricity Supply Company</p>
<p class="tababb"><span class="tababb01">LIRR</span> Long Island Railroad</p>
<p class="tababb"><span class="tababb01">LMS(R)</span> London Midland and Scottish Railway</p>
<p class="tababb"><span class="tababb01">LNER</span> London and North Eastern Railway</p>
<p class="tababb"><span class="tababb01">LNWR</span> London and North Western Railway</p>
<p class="tababb"><span class="tababb01">LPTB</span> London Passenger Transport Board</p>
<p class="tababb"><span class="tababb01">LSWR</span> London and South Western Railway</p>
<p class="tababb"><span class="tababb01">LV</span> low voltage</p>
<p class="tababb"><span class="tababb01">LYR</span> Lancashire and Yorkshire Railway</p>
<p class="tababb"><span class="tababb01">M&amp;EE</span> Mechanical and Electrical Engineering subcommittee</p>
<p class="tababb"><span class="tababb01">MDR</span> Metropolitan District Railway</p>
<p class="tababb"><span class="tababb01">MER</span> Manx Electric Railway</p>
<p class="tababb"><span class="tababb01">MP</span> Member of Parliament</p>
<p class="tababb"><span class="tababb01">NER</span> North Eastern Railway</p>
<p class="tababb"><span class="tababb01">NHS</span> National Health Service</p>
<p class="tababb"><span class="tababb01">REC</span> Railway Executive Committee</p>
<p class="tababb"><span class="tababb01">RFC</span> Royal Flying Corps</p>
<p class="tababb"><span class="tababb01">RNAS</span> Royal Naval Air Service</p>
<p class="tababb"><span class="tababb01">RNVR</span> Royal Naval Volunteer Reserve</p>
<p class="tababb"><span class="tababb01">SCADA</span> supervisory control and data acquisition</p>
<p class="tababb"><span class="tababb01">SECR</span> South Eastern and Chatham Railway</p>
<p class="tababb"><span class="tababb01">V</span> Volt(s)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?c9c428e2